/* ================================================== */
/* EMBEDS → article
/* ================================================== */

$(document).ready(function() {

	$('.bloc-video .formatter').each(function(){
		var iframe = $(this).find('iframe');
		$(this)
			.addClass('js-ratio')
			.attr('data-ratio', (Number(iframe.attr('height')) / Number(iframe.attr('width'))));
	});

});